import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Divider,
  IconButton,
} from "@material-ui/core";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import AddIcon from "@material-ui/icons/Add";
import isSubscribedHelper from "../../helpers/isSubscribedHelper";
import moment from "moment";

const EditSubscriptionDialog = ({
  open,
  close,
  data,
  updateSubscription,
  classes,
  courses,
  byName,
}) => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]); // useState(moment().add(1, 'Y').format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState([]);
  const [hasSubscription, setHasSubscription] = useState();
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [errorText, setErrorText] = useState("");
  const [isDirty, setDirty] = useState([]);
  const [courseNames, setCourseNames] = useState([]);
  const DEFAULT_SUBSCRIPTION = {
    //"_id": "5fd8facaf4434c6d25495e83",
    courseNameAlias: "",
    startDate: moment().format("MM-DD-YYYY"),
    endDate: moment()
      .add(1, "y")
      .format("YYYY-MM-DD"),
    isSubscribed: "",
    processedBy: "Manual",
    subscribedBy: byName,
    status: "",
    isNew: true,
  };

  useEffect(() => {
    let subs = data.map((item) => ({ ...item }));
    console.log(subs)
    const hasSubscriptions = subs.length > 0;
    const names = courses.map((el) => ({ alias: el.alias, name: el.name }));
    setCourseNames(names);
    //remove subscribed courses from list
    if (hasSubscriptions) {
      const subscriptionNames = subs.map((sub) => sub.courseNameAlias);
      const filtered = courses.filter((course) => !subs.includes(course.alias));
      setFilteredCourses(filtered);
    } else {
      setFilteredCourses(courses);
    }
    //Double check out dates, and status for each sub.
    let startDates = [];
    let endDates = [];
    let clean = [];
    hasSubscriptions &&
      subs.forEach((sub, index) => {
        //fix end date
        let endDate = moment(sub.endDate * 1000).format("YYYY-MM-DD");
        if (endDate > "2050-12-31") {
          endDate = moment(sub.endDate).format("YYYY-MM-DD");
        }
        endDates.push(endDate);
        //subscriptions[index].endDate = endDate;
        //WE ONLY LOOK AT IS SUBSCRIBED NOW
        // if(hasSubscription && data.organization_subscriptions[0].active){
        //     setSubscription({...data.organization_subscriptions[0], isSubscribed: true})
        // }
        //To do: filter courses for existing
        //fix startDate
        //let startDateEpoch = data.startDate;
        let startDate = moment(sub.startDate * 1000).format("YYYY");
        if (startDate > "2050") {
          startDate = moment(sub.startDate).format("MM-DD-YYYY");
        } else {
          startDate = moment(sub.startDate * 1000).format("MM-DD-YYYY");
        }
        startDates.push(startDate);
        clean.push(false);
        //subscriptions[index].startDate = startDate;
      });
    setHasSubscription(hasSubscriptions);
    hasSubscriptions && setStartDate(startDates);
    setSelectedDate(
      hasSubscriptions ? endDates : [DEFAULT_SUBSCRIPTION.endDate]
    );
    setSubscriptions(hasSubscriptions ? subs : [DEFAULT_SUBSCRIPTION]);
    setDirty(clean);
  }, []);

  const makeDirty = (index) => {
    let updateDirty = [...isDirty];
    updateDirty[index] = true;
    setDirty(updateDirty);
  };
  const handleChange = (e, index) => {
    let updatedSubs = [...subscriptions];
    updatedSubs[index][e.target.name] = e.target.value;
    if (e.target.name === "isSubscribed") {
      if (e.target.value) {
        updatedSubs[index]["status"] = "active";
      } else if (!e.target.value && updatedSubs[index]["isNew"]) {
        updatedSubs[index]["status"] = "inactive";
      } else {
        updatedSubs[index]["status"] = "canceled";
      }
    }
    setSubscriptions(updatedSubs);
    makeDirty(index);
  };

  const onChangeDate = (e, index) => {
    const value = e.target.value;
    let newSelectedDate = [...selectedDate];
    newSelectedDate[index] = value;
    setSelectedDate(newSelectedDate);
    makeDirty(index);
  };
  const addSubscription = (e) => {
    setSubscriptions([...subscriptions, DEFAULT_SUBSCRIPTION]);
    setSelectedDate([...selectedDate, DEFAULT_SUBSCRIPTION.endDate]);
    setDirty([...isDirty, true]);
  };
  const removeCourse = (index) => {
    let removeSub = [...subscriptions];
    removeSub.splice(index, 1);
    setSubscriptions(removeSub);
    let updateDirty = [...isDirty];
    updateDirty.splice(index, 1);
    setDirty(updateDirty);
  };
  const getDisplayName = (alias) => {
    const index = courseNames.findIndex((el) => el.alias === alias);
    return courseNames[index].name;
  };
  const findDuplicates = (subs) =>
    subs.filter((name, index) => subs.indexOf(name) !== index);

  const resetForm = () => {
    setSubscriptions([]);
    setSelectedDate([]); // useState(moment().add(1, 'Y').format('YYYY-MM-DD'));
    setStartDate([]);
    setHasSubscription("");
    setFilteredCourses([]);
    setErrorText("");
    setDirty([]);
    setCourseNames([]);
  };
  const updateSubs = async (e) => {
    //first validate each sub, otherwise throw and error
    setErrorText("");
    const today = moment().format("YYYY-MM-DD");
    const duplicates = findDuplicates(
      subscriptions.map((el) => el.courseNameAlias)
    );
    const invalidSubs = subscriptions.filter((sub, index) => {
      return (
        !sub.courseNameAlias ||
        typeof sub.isSubscribed !== "boolean" ||
        (sub.isSubscribed && !moment(selectedDate[index]).isAfter(today))
      );
    });
    if (duplicates.length > 0) {
      setErrorText(
        "Duplicate courses. Please ensure only once subscritption per course."
      );
      return "";
    } else if (invalidSubs.length > 0) {
      //validation step - has coursename, status, and expiration date
      setErrorText(
        "Missing information. Please ensure that course, status and expiraton are selected for all subscriptions."
      );
      return "";
    } else {
      const updatedSubscriptions = subscriptions.map((sub, index) => {
        if (sub.isNew || isDirty[index]) {
          const updatedSub = {
            ...sub,
            startDate: moment(sub.startDate).valueOf(),
            endDate: moment(selectedDate[index]).valueOf(),
            processedBy: (sub.processedBy === 'Stripe' && !sub.isSubscribed) ? sub.processedBy : 'Manual', //if cancelling a stripe sub, don't change it to manual. 
            subscribedBy: byName,
            isNew: "",
          };
          // handle expired subscription, and ensure stats = 'active
          if (updatedSub.isSubscribed && updatedSub.status === 'cancelled' && moment(updatedSub.endDate).isAfter(today)){
            updatedSub.status = 'active'
          }
          return updatedSub
        } else {
          return { ...sub };
        }
      });
      await updateSubscription(updatedSubscriptions);
      resetForm();
    }
  };
  const handleClose = () => {
    resetForm();
    close();
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="sm"
      style={{ fontFamily: "sans-serif", minWidth: 600 }}
    >
      <DialogTitle>
        <div
          style={{
            display: "flex",
            flexFlow: "row nowrap",
            justifyContent: "space-between",
          }}
        >
          Update User Subscription
          {subscriptions.length < 3 && (
            <Button
              color="primary"
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={addSubscription}
            >
              Add Subscription
            </Button>
          )}
        </div>
      </DialogTitle>
      <DialogContent>
        {subscriptions.map((sub, index) => (
          <React.Fragment key={`${sub.courseNameAlias}-${index}`}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={6} style={{ padding: "0.5rem" }}>
                <FormControl fullWidth style={{ padding: "0.5rem" }}>
                  <InputLabel shrink id="user-sub-course-label">
                    Course Name:
                  </InputLabel>
                  <Select
                    //autoWidth={true}
                    labelId="user-sub-course-label"
                    id="courseNameAlias"
                    name="courseNameAlias"
                    value={sub.courseNameAlias}
                    onChange={(e) => handleChange(e, index)}
                    required
                    displayEmpty
                    disabled={!sub.isNew}
                  >
                    <MenuItem value="">Select a Course</MenuItem>
                    {!sub.isNew
                      ? courses.map((course) => (
                          <MenuItem value={course.alias}>
                            {getDisplayName(
                              course.alias || sub.courseNameAlias
                            )}
                          </MenuItem>
                        ))
                      : filteredCourses.map((course) => (
                          <MenuItem value={course.alias}>
                            {getDisplayName(
                              course.alias || sub.courseNameAlias
                            )}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={5}>
                <FormControl fullWidth style={{ padding: "0.5rem" }}>
                  <InputLabel id="user-sub-active-label">
                    Subscription Status:
                  </InputLabel>
                  <Select
                    //autoWidth={true}
                    labelId="user-sub-active-label"
                    id="isSubscribed"
                    name="isSubscribed"
                    value={sub.isSubscribed}
                    onChange={(e) => handleChange(e, index)}
                  >
                    <MenuItem value={true}>Subscribed</MenuItem>
                    <MenuItem value={false}>Unsubscribed</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={1}>
                <IconButton
                  aria-label="delete"
                  onClick={(e) => removeCourse(index)}
                  disabled={!sub.isNew}
                >
                  <DeleteForeverIcon />
                </IconButton>
              </Grid>
              <Grid item xs={7} style={{ padding: "0.5rem" }}>
                <div>
                  <b>Subscribed by:</b>{" "}
                  {sub.subscribedBy ? sub.subscribedBy : "N/A"}
                </div>
              </Grid>
              <Grid item xs={5} style={{ padding: "0.5rem" }}>
                <div style={{textTransform: 'capitalize'}}>
                  <b>Type:</b>{" "}
                  {sub.processedBy
                    ? sub.processedBy && sub.status
                      ? `${sub.processedBy} - ${sub.status}`
                      : sub.processedBy
                    : "N/A"}
                </div>
              </Grid>
              {sub.isSubscribed && (
                <>
                  <Grid item xs={7} style={{ padding: "0.5rem" }}>
                    <div>
                      <b>Start Date:</b>&nbsp;&nbsp;&nbsp;{" "}
                      {sub.startDate
                        ? moment(sub.startDate).format("MM/DD/YYYY")
                        : "N/A"}
                    </div>
                  </Grid>
                  <Grid item xs={5} style={{ padding: "0.5rem" }}>
                    <TextField
                      id="date"
                      type="date"
                      error={
                        !moment(selectedDate[index]).isAfter(moment().format())
                      }
                      //defaultValue={selectedDate}
                      value={selectedDate[index]}
                      className={classes.textField}
                      onChange={(e) => onChangeDate(e, index)}
                      fullWidth
                      label="Expiration:"
                      size="small"
                      helperText={
                        !moment(selectedDate[index]).isAfter(moment().format())
                          ? "Date must be after today"
                          : ""
                      }
                    />
                  </Grid>
                </>
              )}
            </Grid>
            <Divider variant="middle" style={{ margin: "15px 0px" }} />
          </React.Fragment>
        ))}
        <div>{errorText}</div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          //onClick={e => console.log(subscriptions, selectedDate)}
          onClick={updateSubs}
          //disabled={subscription.isSubscribed && selectedDate === ''}
          autoFocus
          color="primary"
          variant="contained"
        >
          Update Subscription
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default EditSubscriptionDialog;
